<form [formGroup]="grp">
  @if (hasToggle) {
    <mat-slide-toggle (change)="onToggleChange($event)" color="primary" class="reward-toggle"
      formControlName="dataEnabled">
      <label class="form-label">{{label}}</label>
    </mat-slide-toggle>
  }
  @if (!hasToggle || dataEnabled) {
    <div class="box" fxLayout="column">
      @if (label && !hasToggle) {
        <h5>{{ label }}</h5>
      }
      <div fxLayout="row">
        <div fxLayout="column" fxFlex>
          <!-- PRODUCT -->
          <div fxLayout="row" class="reward-select">
            <mat-form-field fxFlex>
              <mat-label>Product reward</mat-label>
              <mat-select [compareWith]="compareProductRewardFn" placeholder="" formControlName="productReward"
                (selectionChange)="onProductSelected($event)">
                <mat-option [value]="null">(None)</mat-option>
                @for (productReward of rewardProductsOptions; track productReward) {
                  <mat-option [value]="productReward" [matTooltip]="productReward.productSlug">{{ productReward.rewardTitle
                    }}</mat-option>
                }
              </mat-select>
            </mat-form-field>
            <div fxFlex="40px">
              @if (!grp.value?.productReward) {
                <lib-button variant="icon" color="primary" icon="add_circle" tooltip="Add reward product"
                  (buttonClick)="onAddRewardProduct()"></lib-button>
              }
              @if (grp.value?.productReward) {
                <lib-button variant="icon" color="primary" icon="delete" tooltip="Delete reward product"
                  (buttonClick)="onRemoveRewardProduct()"></lib-button>
              }
            </div>
          </div>
          <!-- COINS -->
          @if (allowCoins) {
            <div fxLayout="row">
              <mat-form-field fxFlex>
                <mat-label>Coins reward</mat-label>
                <input matInput type="number" formControlName="coinReward" (change)="onCoinSelected($event)">
                @if (grp.get('coinReward').errors?.min) {
                  <mat-error>Value must be greater than or equal to 0</mat-error>
                }
              </mat-form-field>
            </div>
          }
          <!-- STAMPS -->
          @if (allowStamps) {
            <div fxLayout="row">
              <mat-form-field fxFlex>
                <mat-label>Stamps reward</mat-label>
                <mat-select [compareWith]="compareStampRewardFn" placeholder="" formControlName="stampReward"
                  (selectionChange)="onStampSelected($event)">
                  <mat-option [value]="null"></mat-option>
                  @for (stampReward of stampRewardOptions; track stampReward) {
                    <mat-option [value]="stampReward">{{ stampReward.stamps }}
                      stamps reward</mat-option>
                  }
                </mat-select>
              </mat-form-field>
            </div>
          }
          <!-- POINTS -->
          @if (allowPoints) {
            <div fxLayout="row">
              <mat-form-field fxFlex>
                <mat-label>Points reward</mat-label>
                <input type="number" matInput placeholder="" (change)="onPointChange($event)" formControlName="coinReward"
                  autocomplete="off" min="0">
                <mat-error>Value must be greater than or equal to 0</mat-error>
              </mat-form-field>
            </div>
          }
        </div>
        @if (grp.value?.productReward; as p) {
          <div fxLayout="column" class="product-area">
            <div fxFlex fxLayout="row" fxLayoutGap="20px" class="product-reward">
              <div class="avatar">
                <lib-photo [url]="p.rewardPhotoUrl" [width]="'153px'" [height]="'153px'" [radius]="'10px'"></lib-photo>
              </div>
              <div fxFlex fxLayout="column" fxLayoutAlign="start">
                @if (p?.rewardTitle) {
                  <div class="info-v">
                    <div class="lbl">Reward title</div>
                    <div class="val" [innerHTML]="p.rewardTitle"></div>
                  </div>
                }
                @if (p?.rewardDescription) {
                  <div class="info-v">
                    <div class="lbl">Reward description</div>
                    <div class="val" [innerHTML]="p.rewardDescription"></div>
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </div>
    </div>
  }
</form>